const SHOW_LAYERS_PANEL = 'showLayersPanel';
const HIDE_LAYERS_PANEL = 'hideLayersPanel';
const SET_PREVIEW_MODE = 'layersPanelSetPreviewMode';

export { SHOW_LAYERS_PANEL, HIDE_LAYERS_PANEL, SET_PREVIEW_MODE };
